/**
 * Default input component with label positioned above the input field.
 * For Inputs with side labels, use CustomInput instead.
 */

import React from 'react';

import { FormGroup, Label, StyledTextField } from './styles';
import { DefaultCustomInputProps } from './types';

const DefaultCustomInput: React.FC<DefaultCustomInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  required = false,
}) => {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <StyledTextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        required={required}
        fullWidth
      />
    </FormGroup>
  );
};

export default DefaultCustomInput;
